import { useState, useEffect } from 'react';
import Link from 'next/link';
import { Reaction } from './ReactionButton';
import { CloseIcon } from 'components/common/svgIcons';
import Avatar from 'components/common/Avatar';
import styles from './ReactionModal.module.css';
import { CommunityReactions } from 'types/community';
import { getCommunityProfilePageUrl } from 'lib/community';

type Props = {
  onClose: () => void;
  reactions: CommunityReactions;
};

const ReactionModal = ({ onClose, reactions }: Props) => {
  const [focusedReaction, setFocusedReaction] = useState<string>(
    CommunityReactions.order[0]
  );

  function focusReaction(reaction: string) {
    setFocusedReaction(reaction);
  }

  const users = reactions.getByName(focusedReaction).users;

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  return (
    <div className={styles.Overlay} onClick={onClose}>
      <div className={styles.Container} onClick={(e) => e.stopPropagation()}>
        <div className={styles.Header}>
          <h2>Likes</h2>
          <button onClick={onClose}>
            <CloseIcon />
          </button>
        </div>
        <div className={styles.Reactions}>
          {CommunityReactions.order.map((name) => (
            <div key={name} className={styles.ReactionFilter}>
              {focusedReaction === name && <div className={styles.Selection} />}
              <Reaction
                key={name}
                artboard={name}
                disableHover
                onClick={() => focusReaction(name)}
              />
              <h4>{reactions.getByName(name).count}</h4>
            </div>
          ))}
        </div>
        <div className={styles.Divider} />
        <div className={styles.UserList}>
          {users.map(({ username, avatar }) => (
            <ReactedUser
              key={username}
              username={username}
              avatar={avatar ?? ''}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default ReactionModal;

type ReactedUserProps = {
  username: string;
  avatar: string;
};

const ReactedUser = ({ username, avatar }: ReactedUserProps) => {
  return (
    <Link href={getCommunityProfilePageUrl(username)}>
      <div className={styles.ReactedUser}>
        <div className={styles.AvatarContainer}>
          <Avatar data={{ username, avatar }} />
        </div>
        <h4>{username}</h4>
      </div>
    </Link>
  );
};
